import React, {useEffect, useRef, useState} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormMultilineInput from "../../formComponents/FormMultilineInput";
import FormLinkedItemListSelect from "../../formComponents/FormLinkedItemListSelect";
import FormImage from "../../formComponents/FormImage";
import FormCheckboxGrid from "../../formComponents/FormCheckboxGrid";
import FormCheckbox from "../../formComponents/FormCheckbox";
import FormUrlInput from "../../formComponents/FormUrlInput";
import FormInputWithSuggest from "../../formComponents/FormInputWithSuggest";
import DatesBlock from "./DatesBlock";
import {eventTypeIdSetsByKulturalGoal} from "../../AppVars";
import {clientDateToServerDate, serverDateToClientDate} from "../../utils/DateTimeUtil";
import {getFullName, getShortName} from "../../utils/PersonNameUtil";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";
import {FormHelperText} from "@mui/material";
import FormLinkedItemSimpleSelect from "../../formComponents/FormLinkedItemSimpleSelect";
import {allAges, allArtistRoles, allSchoolClasses} from "../../data/Enums";
import FormRewardsSelect from "../../formComponents/FormRewardsSelect";

const EventsTheatreItemForm = ({initData, controlRef, pageOptions}) => {

    const controlRefName = useRef(null);
    const controlRefDescription = useRef(null);
    const controlRefType = useRef(null);
    const controlRefGenre = useRef(null);
    const controlRefCover = useRef(null);
    const controlRefCity = useRef(null);
    const controlRefLocation = useRef(null);

    const controlRefDirectors = useRef(null);
    const controlRefAuthors = useRef(null);
    const controlRefComposers = useRef(null);
    const controlRefChoreographers = useRef(null);

    const controlRefLiteraryWorks = useRef(null);
    const controlRefHistFigures = useRef(null);
    const controlRefTags = useRef(null);
    const controlRefMinAge = useRef(null);
    const controlRefSchoolClasses = useRef(null);
    const controlRefDuration = useRef(null);
    const controlRefPremiereDate = useRef(null);
    const controlRefIsPushkinCardAccepted = useRef(null);
    const controlRefAwards = useRef(null);
    const controlRefOlympiads = useRef(null);
    const controlRefFestivals = useRef(null);
    const controlRefUrl = useRef(null);
    const controlRefArchived = useRef(null);

    const [artistsErrorMessage, setArtistsErrorMessage] = useState("");

    const [selectedCityId, setSelectedCityId] = useState(initData?.refs?.locations?.[initData?.location_id ?? null]?.city_id);
    const [selectedLocationId, setSelectedLocationId] = useState(initData?.location_id);

    // TODO?
    function getArtistGroupControlRef(role) {
        if (role === "director") return controlRefDirectors;
        if (role === "writer") return controlRefAuthors;
        if (role === "composer") return controlRefComposers;
        if (role === "choreographer") return controlRefChoreographers;
        throw new Error("invalid role!");
    }

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(500))
            isValid = false;

        if (!controlRefType.current.validateIsSelected("Нужно выбрать тип!"))
            isValid = false;

        if (!controlRefGenre.current.validateLength(255))
            isValid = false;

        if (!controlRefDescription.current.validateLength(2000))
            isValid = false;

        if (!controlRefCity.current.validateIsSelected("Нужно выбрать город!"))
            isValid = false;

        if (selectedCityId && !controlRefLocation.current.validateIsSelected("Нужно выбрать локацию!"))
            isValid = false;

        if (!controlRefUrl.current.validateNotEmpty("Нужно указать сайт!"))
            isValid = false;
        else if (!controlRefUrl.current.validateUrl("Неверно указан адрес сайта!"))
            isValid = false;
        else if (!controlRefUrl.current.validateLength(2000))
            isValid = false;

        if (!controlRefAwards.current.validateYears())
            isValid = false;
        if (!controlRefOlympiads.current.validateYears())
            isValid = false;
        if (!controlRefFestivals.current.validateYears())
            isValid = false;

        const genre = controlRefGenre.current.getText();
        if (!genre.includes("экскурсия") &&
            !(genre.includes("лекция")) &&
            genre !== "мастер-класс") {
            if (artistGroupInfos.every(g => getArtistGroupControlRef(g.role).current.getIsEmpty())) {
                setArtistsErrorMessage("Нужно указать хотя бы одного деятеля!");
                isValid = false;
            }
        }

        if (!controlRefMinAge.current.validateIsSelected("Нужно указать возрастное ограничение!"))
            isValid = false;

        /*if (!controlRefMinAge.current.validateNotEmpty("Нужно указать возрастное ограничение!"))
            isValid = false;
        else if (!controlRefMinAge.current.validateText("Неверно указано возрастное ограничение!"))
            isValid = false;*/

        if (!controlRefDuration.current.validateText("Неверно указана продолжительность!"))
            isValid = false;

        if (!controlRefPremiereDate.current.validateText("Неверно указана дата!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            kultural_goal: pageOptions.kultural_goal,
            type_id: controlRefType.current.getSelectedId(),
            name: controlRefName.current.getText(),
            description: controlRefDescription.current.getText(),
            genre: controlRefGenre.current.getText(),
            cover_base64: controlRefCover.current.isChangedToImage() ? controlRefCover.current.getBase64() : null,
            clear_cover: controlRefCover.current.isChangedToCleared() ? true : null,
            location_id: selectedLocationId,
            artists: getArtistsData(),
            literary_work_ids: controlRefLiteraryWorks.current.getSelectedIds(),
            tag_ids: controlRefTags.current.getSelectedIds(),
            is_for_toddlers: controlRefSchoolClasses.current.getPreExtraItemChecked(),
            school_classes: controlRefSchoolClasses.current.getCheckedIds(),
            is_for_adults: controlRefSchoolClasses.current.getPostExtraItemChecked(),
            min_age: getAgeData(controlRefMinAge),
            duration: getDurationData(),
            premiere_date: getPremiereDateData(),
            is_pushkin_card_accepted: controlRefIsPushkinCardAccepted.current.getChecked(),
            reward_years: getRewardYearsData(),
            url: controlRefUrl.current.getUrl(),
            is_deleted: initData && controlRefArchived.current.getChecked(),
        }
    }

    function getRewardYearsData() {
        const options = [...controlRefAwards.current.getSelectedOptions(), ...controlRefOlympiads.current.getSelectedOptions(), ...controlRefFestivals.current.getSelectedOptions()];
        return options.map(x => ({reward_id: x.id, year_start: x.year1, year_end: x.year2}));
    }

    function getArtistsData() {
        return [
            ...artistGroupInfos.map(g => getArtistGroupControlRef(g.role).current.getSelectedIds().map(id => ({
                id: id,
                role: g.role
            }))).flat(),
            ...controlRefHistFigures.current.getSelectedIds().map(x => ({id: x, role: "historical_figure"})),
        ];
    }

    function getDurationData() {
        const str = controlRefDuration.current.getText();
        if (str === "")
            return null;

        const regex = /^(\d+)\s*:\s*(\d+)$/;
        const match = regex.exec(str);
        const h = parseInt(match[1]);
        const m = parseInt(match[2]);
        return (h * 60 + m) * 60; // [sec]
    }

    function getPremiereDateData() {
        const str = controlRefPremiereDate.current.getText();
        return str === "" ? null : clientDateToServerDate(str);
    }

    function renderInitialLiteraryWorkItemExtraInfo(item, className) {
        return <span className={className}>{getInitialAuthorName(item.id)}</span>
    }

    function getInitialAuthorName(literaryWorkId) {
        const work = initData?.refs?.literary_works?.[literaryWorkId];
        if (!work)
            return "?";

        if (work.author_id === null)
            return "(без автора)";

        const author = initData?.refs?.artists?.[work.author_id];
        return author ? getShortName(author.first_name, author.last_name, author.middle_name) : "?";
    }

    function renderInitialArtistItemExtraInfo(item, className) {
        return <span className={className}>{getInitialArtistMainRoleName(item.id)}</span>
    }

    function getInitialArtistMainRoleName(artistId) {
        const artist = initData?.refs?.artists?.[artistId];
        if (!artist)
            return "?";

        return allArtistRoles.find(x => x.id === artist.main_role)?.name ?? "?";
    }

    function renderArtistGroupListSelect(groupInfo) {
        return <FormLinkedItemListSelect
            controlRef={getArtistGroupControlRef(groupInfo.role)}
            key={groupInfo.role}
            selectedItemsAreaType="column"
            label={groupInfo.label}
            inputWidthLimit={500}
            selectedItemsAreaWidthLimit={700}
            initSelectedIds={initData?.artists?.filter(x => x.role === groupInfo.role).map(x => x.artist_id) ?? []}
            initRefList={initData?.refs?.artists}
            apiName2="artists"
            showIds={true}
            itemNameFunc={item => getFullName(item.first_name, item.last_name, item.middle_name)}
            onChange={value => {
                setArtistsErrorMessage("")
            }}
            renderItemExtraInfoFunc={renderArtistItemExtraInfo}
            renderInitialItemExtraInfoFunc={renderInitialArtistItemExtraInfo}
        />
    }

    return (
        <BaseSimpleItemEditorForm>
            {initData && <DatesBlock
                dates={initData.dates ?? []}
            />}
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={500}
                    initValue={initData?.name ?? ""}
                />
                <FormLinkedItemSelect
                    controlRef={controlRefType}
                    label="Тип"
                    widthLimit={350}
                    initSelectedId={initData?.type_id}
                    initRefList={initData?.refs?.types}
                    apiName2="types"
                    showIds={true}
                    itemFilterFunc={item => filterEventType(item, pageOptions.kultural_goal)}
                />
                <FormInputWithSuggest
                    controlRef={controlRefGenre}
                    label="Жанр"
                    widthLimit={400}
                    initValue={initData?.theatre_details?.genre ?? ""}
                    apiName2="genres"
                    showIds={true}
                    placeholder={"(не указан)"}
                    tipText={"При вводе текста автоматически будут предлагаться готовые названия жанра.\nЕсли нужный вариант не найден, то введите его в поле самостоятельно, игнорируя предлагаемые варианты.\n"}
                />
                <FormMultilineInput
                    controlRef={controlRefDescription}
                    label="Краткое описание"
                    widthLimit={700}
                    initValue={initData?.description ?? ""}
                    maxVisibleRows={6}
                />
                <FormImage
                    controlRef={controlRefCover}
                    label="Постер"
                    initImageUrl={initData?.cover_url ?? ""}
                    imageViewSize={250}
                    imageCanvasMaxSize={250}
                />
            </FormBlock>
            <FormBlock title="Место">
                <FormLinkedItemSelect
                    controlRef={controlRefCity}
                    label="Город"
                    widthLimit={500}
                    initSelectedId={selectedCityId}
                    initRefList={initData?.refs?.cities}
                    apiName2="cities"
                    showIds={true}
                    onSelect={id => {
                        setSelectedCityId(id);
                        setSelectedLocationId(undefined);
                    }}
                    renderItemExtraInfoFunc={renderCityItemExtraInfo}
                />
                <FormLinkedItemSelect
                    locked={!Boolean(selectedCityId)}
                    lockedMessage={"Сначала нужно выбрать город!"}
                    controlRef={controlRefLocation}
                    key={selectedCityId}
                    label="Локация"
                    widthLimit={850}
                    initSelectedId={selectedLocationId}
                    initRefList={initData?.refs?.locations}
                    apiName2="locations"
                    filterExtraParams={{city_id: selectedCityId}}
                    showIds={true}
                    onSelect={setSelectedLocationId}
                />
            </FormBlock>
            <FormBlock title="Создатели и постановщики">
                {artistsErrorMessage && <FormHelperText error sx={{
                    marginLeft: "14px",
                    marginTop: "-12px"
                }}>{artistsErrorMessage}</FormHelperText>}
                {artistGroupInfos.map(renderArtistGroupListSelect)}
            </FormBlock>
            <FormBlock title="Связи">
                <FormLinkedItemListSelect
                    controlRef={controlRefLiteraryWorks}
                    label="Литературные источники"
                    inputWidthLimit={450}
                    initSelectedIds={initData?.literary_work_ids ?? []}
                    initRefList={initData?.refs?.literary_works} // TODO: должны содержать author_id (уже?)
                    apiName2="literary_works"
                    showIds={true}
                    selectedItemsAreaType="column"
                    renderItemExtraInfoFunc={renderLiteraryWorkItemExtraInfo}
                    renderInitialItemExtraInfoFunc={renderInitialLiteraryWorkItemExtraInfo}
                    dataRefs={initData?.refs}
                />
                <FormLinkedItemListSelect
                    controlRef={controlRefHistFigures}
                    label="Исторические личности"
                    selectedItemsAreaType="column"
                    inputWidthLimit={500}
                    selectedItemsAreaWidthLimit={700}
                    initSelectedIds={initData?.artists?.filter(x => x.role === "historical_figure").map(x => x.artist_id) ?? []} // TODO? упростить данные?
                    initRefList={initData?.refs?.artists}
                    apiName2="artists"
                    showIds={true}
                    itemNameFunc={item => getFullName(item.first_name, item.last_name, item.middle_name)}
                    renderItemExtraInfoFunc={renderArtistItemExtraInfo}
                    renderInitialItemExtraInfoFunc={renderInitialArtistItemExtraInfo}
                />
                <FormLinkedItemListSelect
                    controlRef={controlRefTags}
                    label="Теги"
                    inputWidthLimit={450}
                    selectedItemsAreaWidthLimit={700}
                    initSelectedIds={initData?.tag_ids ?? []}
                    initRefList={initData?.refs?.tags}
                    apiName2="tags"
                    showIds={true}
                />
            </FormBlock>
            <FormBlock title="Возрастные категории">
                <FormCheckboxGrid
                    controlRef={controlRefSchoolClasses}
                    /*label="Возрастные категории"*/
                    widthLimit={670}
                    initItems={allSchoolClasses.map(x => ({
                        ...x,
                        label: `${x.id} класс`,
                        extraInfoText: `${x.ageText} лет`,
                        checked: initData?.classes?.includes(x.id) ?? false
                    }))}
                    preExtraItem={{
                        label: "Для самых маленьких",
                        extraInfoText: "0-5 лет",
                        checked: initData?.is_for_toddlers ?? false,
                    }}
                    postExtraItem={{
                        label: "Для взрослых",
                        extraInfoText: "18+ лет",
                        checked: initData?.is_for_adults ?? false,
                    }}
                />
            </FormBlock>
            <FormBlock title="Инфо">
                <FormLinkedItemSimpleSelect
                    controlRef={controlRefMinAge}
                    label="Возрастное ограничение (официальное)"
                    widthLimit={150}
                    initSelectedId={initData?.min_age ?? undefined}
                    options={allAges}
                />
                <FormInput
                    controlRef={controlRefDuration}
                    label="Продолжительность"
                    widthLimit={100}
                    initValue={getInitialDuration(initData?.duration)}
                    placeholder="Ч:ММ"
                    validateTextFunc={text => !text || validateDuration(text, false)}
                />
                <FormInput
                    controlRef={controlRefPremiereDate}
                    label="Дата премьеры"
                    widthLimit={130}
                    initValue={getInitialDate(initData?.theatre_details?.premiere_date)}
                    placeholder="ДД.ММ.ГГГГ"
                    validateTextFunc={text => !text || validateDate(text)}
                />
                <FormCheckbox
                    controlRef={controlRefIsPushkinCardAccepted}
                    label="Пушкинская карта"
                    initValue={initData?.is_pushkin_card_accepted ?? false}
                />
                {renderRewardsSelect(controlRefAwards, "Награды", initData, "award")}
                {renderRewardsSelect(controlRefOlympiads, "Олимпиады", initData, "olympiad")}
                {renderRewardsSelect(controlRefFestivals, "Фестивали", initData, "festival")}
                <FormUrlInput
                    controlRef={controlRefUrl}
                    label="Сайт (события)"
                    widthLimit={500}
                    initValue={initData?.url ?? ""}
                    placeholder="https://..."
                />
            </FormBlock>
            {initData && <FormBlock title="Специальные">
                <FormCheckbox
                    controlRef={controlRefArchived}
                    label="Архивная карточка"
                    initValue={Boolean(initData?.deleted_at)}
                    tipText={"Архивные карточки хранятся в базе данных, но не используются в работе.\nПереключая данную галку, можно делать карточку архивной и наоборот.\nЧтобы применить выбор, нужно также выполнить Сохранение карточки."}
                />
            </FormBlock>}
        </BaseSimpleItemEditorForm>
    );
};

function renderRewardsSelect(controlRef, label, initData, kind) {
    return <FormRewardsSelect
        controlRef={controlRef}
        selectedItemsAreaType="column"
        label={label}
        inputWidthLimit={450}
        selectedItemsAreaWidthLimit={700}
        initSelectedOptions={initData?.reward_years?.filter(x => getInitialRewardKindById(x.reward_id, initData) === kind).map(x => ({
            id: x.reward_id,
            year1: x.year_start ?? null,
            year2: x.year_end ?? null,
        })) ?? []}
        initRefList={initData?.refs?.rewards}
        apiName2="rewards"
        showIds={true}
        filterExtraParams={{kinds: kind}}
    />
}

function getInitialRewardKindById(rewardId, initData) {
    const result = initData?.refs?.rewards?.[rewardId]?.kind ?? "";
    if (!result)
        console.error(`can't detect reward kind from refs for rewardId=${rewardId}}`);
    return result;
}

// 01:20 --> 1:20
function getInitialDuration(serverDuration) {
    if (!serverDuration)
        return "";

    const regex = /^(\d+):(\d+)$/
    const match = regex.exec(serverDuration.trim());
    return `${parseInt(match[1])}:${match[2].padStart(2, "0")}`;
}

function getInitialDate(serverValue) {
    return !serverValue ? "" : serverDateToClientDate(serverValue);
}

/*function validateAge(str) {
    if (str === "")
        return true;

    // N
    // N+
    const regex = /^(\d+)\s*\+?$/;
    const match = regex.exec(str);
    if (!match)
        return false;
    const num = parseInt(match[1]);
    return num >= 0 && num <= 18;
}*/

function validateDuration(str, zeroAllowed = true) {
    const regex = /^(\d+)\s*:\s*(\d+)$/;
    const match = regex.exec(str);
    if (!match)
        return false;
    const h = parseInt(match[1]);
    const m = parseInt(match[2]);
    if ((!zeroAllowed && (h + m) === 0) || m >= 60)
        return false;
    return true;
}

function validateDate(str) {
    const regex = /^(\d+)\s*\.\s*(\d+)\s*\.\s*(\d+)$/
    const match = regex.exec(str);
    if (!match)
        return false;
    const d = parseInt(match[1]);
    const m = parseInt(match[2]);
    if (d === 0 || m === 0 || d > 31 || m > 12)
        return false;
    return true;
}

/*function getAgeData(controlRef) {
    const str = controlRef.current.getText();
    if (str === "")
        return null;

    const regex = /^(\d+)\s*\+?$/;
    return parseInt(regex.exec(str)[1]);
}*/

function renderLiteraryWorkItemExtraInfo(item, className, dataRefs) {
    return <span className={className}>{getAuthorName(item.author_id, dataRefs)}</span>
}

function getAuthorName(authorId, dataRefs) {
    if (authorId === null)
        return "(без автора)";

    const author = dataRefs?.authors?.[authorId];
    return author ? getShortName(author.first_name, author.last_name, author.middle_name) : "?";
}

function renderArtistItemExtraInfo(item, className, dataRefs) {
    return <span className={className}>{allArtistRoles.find(x => x.id === item.main_role)?.name ?? "?"}</span>
}

function filterEventType(item, kulturalGoal) {
    return eventTypeIdSetsByKulturalGoal[kulturalGoal].includes(item.id);
}

const artistGroupInfos = [
    {role: "director", label: "Режиссёры"},
    {role: "writer", label: "Авторы"},
    {role: "composer", label: "Композиторы"},
    {role: "choreographer", label: "Хореографы"},
];

function getAgeData(ageControlRef) {
    const selectedId = ageControlRef.current.getSelectedId();
    return selectedId === -1 ? null : selectedId;
}

function renderCityItemExtraInfo(item, className, dataRefs) {
    if (item.is_region_city)
        return null;

    const regionTitle = dataRefs?.regions?.[item.region_id]?.name ?? "?";
    return <span className={className}>{regionTitle}</span>
}

export default EventsTheatreItemForm;